import { useState, useEffect, useCallback } from 'react';

import useAuth from 'providers/Auth/useAuth';
import CourseContext from './context';

import { getMyCourses, getCurrentCourse, selectCourse as apiSelectCourse } from 'services/API/Course';

const CourseProvider = ({ children }) => {
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCourseId, setSelectedCourseId] = useState(null);

  const reload = useCallback(() => {
    if (!user) {
      setCourses([]);
      setSelectedCourseId(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    getMyCourses()
      .then(res => {
        const list = res.data || [];
        setCourses(list);
        return getCurrentCourse().then(resCurrent => ({ list, current: resCurrent.data }));
      })
      .then(({ list, current }) => {
        if (current?.id) {
          setSelectedCourseId(current.id);
        } else {
          // Pas de course sélectionnée : la première accessible fait office de courante
          setSelectedCourseId(prev => prev ?? list[0]?.id ?? null);
        }
      })
      .catch(() => {
        setCourses([]);
        setSelectedCourseId(null);
      })
      .finally(() => setLoading(false));
  }, [user]);

  useEffect(() => {
    reload();
  }, [reload]);

  const selectCourse = async courseId => {
    await apiSelectCourse(courseId);
    setSelectedCourseId(courseId);
  };

  const selectedCourse = courses.find(c => c.id === selectedCourseId) ?? null;

  return (
    <CourseContext.Provider
      value={{
        courses,
        loading,
        selectedCourseId,
        selectedCourse,
        reload,
        selectCourse,
      }}>
      {children}
    </CourseContext.Provider>
  );
};

export default CourseProvider;
